import React from 'react';
import './PageTemplate.css';

/**
 * Standard shell for non-Home routes: primary column plus an optional
 * full-height rightbar. The footer is app chrome, rendered by App.js.
 */
function PageTemplate({ header, rightbar = null, children }) {
  return (
    <div className="page-template column">
      <div className={`page-template-shell${rightbar ? ' page-template-shell--with-rightbar' : ''}`}>
        <div className="page-template-primary column">
          {header != null && header !== false ? (
            <div className="page-template-header">{header}</div>
          ) : null}
          <main className="page-template-main column">{children}</main>
        </div>
        {rightbar ? <aside className="page-template-rightbar column">{rightbar}</aside> : null}
      </div>
    </div>
  );
}

export default PageTemplate;
